import { Factory } from "../../core/factory";

export const registerComponentPlugin = plugin => {
    Factory.registerComponentPlugin(plugin.type, plugin);
};
//# sourceMappingURL=register.js.map
